"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.returnOrderApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var returnOrderApi = exports.returnOrderApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: '/returnOrder',
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: '/returnOrder',
      data: data,
      method: 'post'
    });
  },
  delete: function _delete(id) {
    return (0, _request.default)({
      url: "/returnOrder/".concat(id),
      method: 'delete'
    });
  }
};